module.exports = __webpack_public_path__ + "2838b8fb84fd4c951fda8ccbf220026c.jpg";